import {PolymerElement, html} from '@polymer/polymer';
import '@shoelace-style/shoelace/dist/components/checkbox/checkbox.js';

class KeliBrowseMultiselectToggle extends PolymerElement {
  static get template() {
    return html`
<style>
  #toggle {
    /* Set a very small font size so the label is tiny. */
    --sl-input-font-size-medium: 1px;
  }
</style>

<sl-checkbox id="toggle" checked$="{{selected}}" indeterminate="{{indeterminate}}" on-click="handleClick" on-sl-change="checkedChanged"></sl-checkbox>`;
  }

  static get is() {
    return 'keli-browse-multiselect-toggle';
  }

  static get properties() {
    return {
      rowId: String,
      selected: {type: Boolean},
      indeterminate: {type: Boolean},
      selectingRange: {type: Boolean},
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('dblclick', this.preventPropagation, true);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('dblclick', this.preventPropagation, true);
  }

  preventPropagation(event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  handleClick(event) {
    event.stopPropagation();
    this.selectingRange = event.shiftKey;
  }

  checkedChanged(event) {
    this.selected = event.target.checked;
    this.indeterminate = event.target.indeterminate;
    this.dispatchEvent(new CustomEvent('keliMultiSelectChanged', {
      bubbles: true,
      composed: true,
      detail: {
        id: this.rowId,
        state: (this.indeterminate ? null : !!this.selected),
        modifier: this.selectingRange
      }
    }));
  }
}

customElements.define(KeliBrowseMultiselectToggle.is, KeliBrowseMultiselectToggle);
export {KeliBrowseMultiselectToggle};
